import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.parse-int.js";
import { getImgFromStr, getDateTimeStamp, getDateDiff, toDecimal, getPowerDownDateDiff, timestampToTime } from "../unit/public";
import dsteem from "../unit/DsteemUtil";
import { getAccount, extractLoginData } from "../unit/UserUtil";
import { $t } from "../plugins/i18n";
import { ArrowDown, Plus } from "@element-plus/icons-vue";
import { getAllBoylikegirlClubOperTypeList, getAllBoylikegirlClubPointList, getAllBoylikegirlClubTotalPoints, getSbiBalance, getUVFBalance } from "../apis/services/steemActivity";
import { getGetSp } from "../unit/Tools";
import TransWithAcitveKey from "../components/TransWithAcitveKey.vue";
import PowerUpWithAcitveKey from "../components/PowerUpWithAcitveKey.vue";
import PowerDownWithAcitveKey from "../components/PowerDownWithAcitveKey.vue";
import DelegateWithAcitveKey from "../components/DelegateWithAcitveKey.vue";
import { ElMessage, ElLoading } from "element-plus";
import { getIncomingDelegations, getOutgoingDelegations, getExpiringDelegations } from "../apis/services/steemworld_api";
export default {
  components: {
    ArrowDown: ArrowDown,
    TransWithAcitveKey: TransWithAcitveKey,
    PowerUpWithAcitveKey: PowerUpWithAcitveKey,
    PowerDownWithAcitveKey: PowerDownWithAcitveKey,
    DelegateWithAcitveKey: DelegateWithAcitveKey,
    Plus: Plus
  },
  data: function data() {
    var checkTransferAmount = function checkTransferAmount(rule, value, callback) {
      if (!value && value <= 0) {
        return callback(new Error($t("error.transferAmountError")));
      }

      callback();
    };

    return {
      editableTabsValue: "1",
      editableTabs: [{
        title: $t("label.SteemWallet"),
        name: "1",
        tableData: []
      }, {
        title: $t("label.PointsWallet"),
        name: "2",
        boylikegirlClubOperTypeList: [],
        boylikegirlClubOperPointList: []
      }, {
        title: $t("label.Delegations"),
        name: "3",
        outgoingList: [],
        incomingList: [],
        expiringList: [],
        search: ""
      }],
      blogs: null,
      headImg: "",
      userName: "",
      location: "",
      about: "",
      postCount: 0,
      steem: 0,
      sp: 0,
      sbd_balance: 0,
      votingPower: 0,
      points: 0,
      sbi: 0,
      uvf: 0,
      isOpenTransfer: false,
      fromUser: "",
      isHaveRewards: false,
      ruleForm: {
        transferAmount: "",
        toUser: "",
        memo: "",
        transferType: "STEEM",
        powerUpAmount: "",
        powerDownAmount: "",
        availableSP: ""
      },
      currentUserName: "",
      loginData: "",
      isSelf: false,
      rules: {
        toUser: [{
          required: true,
          message: $t("error.toError"),
          trigger: "blur"
        }],
        transferAmount: [{
          validator: checkTransferAmount,
          trigger: "blur"
        }],
        powerUpAmount: [{
          validator: checkTransferAmount,
          trigger: "blur"
        }],
        powerDownAmount: [{
          validator: checkTransferAmount,
          trigger: "blur"
        }],
        availableSP: [{
          validator: checkTransferAmount,
          trigger: "blur"
        }]
      },
      isShowModel: false,
      isOpenPowerUp: false,
      isShowModelPowerUp: false,
      isOpenPowerDown: false,
      isShowModelPowerDown: false,
      isPownDown: false,
      isOpenCancelPowerDown: false,
      isOpenDelegate: false,
      isShowModelDelegate: false,
      acitveKey: "",
      isLogining: false,
      next_vesting_withdrawal: "",
      to_withdraw: 0,
      powerDownSteem: 0
    };
  },
  methods: {
    pwoerdownDateDiff: function pwoerdownDateDiff(dateTime) {
      return getPowerDownDateDiff(getDateTimeStamp(dateTime));
    },
    dateDiff: function dateDiff(dateTime) {
      return getDateDiff(getDateTimeStamp(dateTime));
    },
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var account;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getAccount(_this.userName);

              case 2:
                account = _context.sent;
                _this.headImg = account.profile_image;
                _this.location = account.location;
                _this.likeid = account.likeid;
                _this.about = account.about;
                _this.postCount = account.post_count;
                _this.steem = account.balance;
                _this.sbd_balance = account.sbd_balance;
                _this.votingPower = account.voting_power;
                _this.next_vesting_withdrawal = account.next_vesting_withdrawal;
                _this.isPownDown = account.to_withdraw != 0 && _this.next_vesting_withdrawal > "2019-01-01T00:00:00";
                _this.points = account.points;
                _this.sbi = account.sbi;
                _this.to_withdraw = account.to_withdraw;
                _this.vesting_shares = account.vesting_shares;
                _this.withdrawn = account.withdrawn;
                _this.delegated_vesting_shares = account.delegated_vesting_shares;
                _this.reward_sbd_balance = account.reward_sbd_balance;
                _this.reward_steem_balance = account.reward_steem_balance;
                _this.reward_vesting_balance = account.reward_vesting_balance;
                _this.reward_vesting_steem = parseFloat(account.reward_vesting_steem);

                if (_this.reward_vesting_steem > 0 || parseFloat(_this.reward_vesting_balance) > 0) {
                  _this.isHaveRewards = true;
                }

                _context.next = 26;
                return getGetSp(account);

              case 26:
                _this.sp = _context.sent;

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onRefresh: function onRefresh(done) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dsteem.getAccountBlogs(_this2.userName, 20);

              case 2:
                _this2.blogs = _context2.sent;
                done();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    claimReward: function claimReward() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var op;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isClaiming = true;
                op = [["claim_reward_balance", {
                  account: _this3.userName,
                  reward_steem: _this3.reward_steem_balance,
                  reward_sbd: _this3.reward_sbd_balance,
                  reward_vests: _this3.reward_vesting_balance
                }]];
                _context3.prev = 2;

                if (!(_this3.loginData[4] == "true")) {
                  _context3.next = 7;
                  break;
                }

                window.steem_keychain.requestBroadcast(_this3.userName, op, "posting", function (response) {
                  //
                  location.reload();
                });
                _context3.next = 10;
                break;

              case 7:
                _context3.next = 9;
                return dsteem.sendOperations(op, _this3.loginData[1]);

              case 9:
                location.reload();

              case 10:
                _context3.next = 14;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](2);

              case 14:
                _this3.isClaiming = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 12]]);
      }))();
    },
    onLoad: function onLoad(done) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var permlink, nextblogs;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.blogs[_this4.blogs.length - 1]) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                permlink = _this4.blogs[_this4.blogs.length - 1].permlink;
                _context4.next = 5;
                return dsteem.getAccountBlogs(_this4.userName, 20, permlink);

              case 5:
                nextblogs = _context4.sent;
                nextblogs.shift();

                _this4.blogs.push.apply(_this4.blogs, nextblogs);

                done();

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    openTransfer: function openTransfer(transferType) {
      this.isOpenTransfer = true;
      if (transferType) this.ruleForm.transferType = transferType;
    },
    finishTransfer: function finishTransfer() {
      ElMessage({
        message: this.$t("success.transSuccess"),
        type: "success"
      });
      this.isShowModel = false;
      this.isOpenTransfer = false;
    },
    confirmTransfer: function confirmTransfer() {
      var _this5 = this;

      this.$refs["ruleForm"].validate(function (valid) {
        if (valid) {
          if (_this5.loginData[4] == "true") {
            var permlink = Math.random().toString(36).substring(2);
            var that = _this5;
            var transferAmount = toDecimal(_this5.ruleForm.transferAmount, 3);
            window.steem_keychain.requestTransfer(_this5.fromUser, _this5.ruleForm.toUser, transferAmount, _this5.ruleForm.memo, _this5.ruleForm.transferType, function (response) {
              if (response.success) {
                that.finishTransfer();
              } else {
                ElMessage({
                  message: that.$t("error.transError"),
                  type: "error"
                });
              }
            });
          } else {
            try {
              _this5.isShowModel = true;
            } catch (e) {//
            }
          }
        } else {
          return false;
        }
      });
    },
    openPowerUp: function openPowerUp() {
      this.isOpenPowerUp = true;
    },
    finishPowerUp: function finishPowerUp() {
      ElMessage({
        message: this.$t("success.powerUpSuccess"),
        type: "success"
      });
      this.isShowModelPowerUp = false;
      this.isOpenPowerUp = false;
    },
    confirmPowerUp: function confirmPowerUp() {
      var _this6 = this;

      this.$refs["ruleForm"].validate(function (valid) {
        if (valid) {
          if (_this6.loginData[4] == "true") {
            var that = _this6;
            var powerUpAmount = toDecimal(_this6.ruleForm.powerUpAmount, 3);
            window.steem_keychain.requestPowerUp(_this6.fromUser, _this6.fromUser, powerUpAmount, function (response) {
              if (response.success) {
                that.finishPowerUp();
              } else {
                ElMessage({
                  message: that.$t("error.powerUpError"),
                  type: "error"
                });
              }
            });
          } else {
            try {
              _this6.isShowModelPowerUp = true;
            } catch (e) {//
            }
          }
        } else {
          return false;
        }
      });
    },
    openPowerDown: function openPowerDown() {
      this.isOpenPowerDown = true;
    },
    finishPowerDown: function finishPowerDown() {
      ElMessage({
        message: this.$t("success.powerDownSuccess"),
        type: "success"
      });
      this.isShowModelPowerDown = false;
      this.isOpenPowerDown = false;
    },
    confirmPowerDown: function confirmPowerDown() {
      var _this7 = this;

      this.$refs["ruleForm"].validate(function (valid) {
        if (valid) {
          if (_this7.loginData[4] == "true") {
            var permlink = Math.random().toString(36).substring(2);
            var that = _this7;
            var powerDownAmount = toDecimal(_this7.ruleForm.powerDownAmount, 3);
            window.steem_keychain.requestPowerDown(_this7.fromUser, powerDownAmount, function (response) {
              if (response.success) {
                that.finishPowerDown();
              } else {
                ElMessage({
                  message: that.$t("error.powerDownError"),
                  type: "error"
                });
              }
            });
          } else {
            try {
              _this7.isShowModelPowerDown = true;
            } catch (e) {//
            }
          }
        } else {
          return false;
        }
      });
    },
    isCancelPowerDown: function isCancelPowerDown() {
      if (this.loginData[4] == "true") {
        var that = this;
        window.steem_keychain.requestPowerDown(this.fromUser, 0, function (response) {
          if (response.success) {
            that.finishPowerDown();
          } else {
            ElMessage({
              message: that.$t("error.powerDownError"),
              type: "error"
            });
          }
        });
      } else {
        this.isOpenCancelPowerDown = true;
      }
    },
    cancelPowerDown: function cancelPowerDown() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this8.acitveKey) {
                  _context5.next = 4;
                  break;
                }

                _this8.errorMessage = "activeKeyError";
                _this8.isLoginError = true;
                return _context5.abrupt("return");

              case 4:
                _this8.isLogining = true;
                _context5.prev = 5;
                _context5.next = 8;
                return dsteem.powerDown(_this8.fromUser, 0, _this8.acitveKey);

              case 8:
                result = _context5.sent;

                if (result) {
                  _this8.isLoginError = false;
                  _this8.errorMessage = "";
                  _this8.isLogining = false;

                  _this8.$emit("comfirmPowerDown");

                  _this8.isOpenCancelPowerDown = false;
                }

                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](5);

                if (_context5.t0.jse_info.code == 10) {
                  _this8.isLoginError = true;
                  _this8.errorMessage = "balanceError";
                } else {
                  _this8.isLoginError = true;
                  _this8.errorMessage = "activeKeyError";
                }

              case 15:
                _this8.isLogining = false;

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[5, 12]]);
      }))();
    },
    openDelegate: function openDelegate() {
      var avail = parseFloat(this.vesting_shares) - (parseFloat(this.to_withdraw) - parseFloat(this.withdrawn)) / 1e6 - parseFloat(this.delegated_vesting_shares);
      this.ruleForm.availableSP = parseFloat(parseFloat(this.total_vesting_fund_steem) * (parseFloat(avail) / parseFloat(this.total_vesting_shares)), 6).toFixed(3);
      this.isOpenDelegate = true;
    },
    delegateEdit: function delegateEdit(index, row) {
      this.ruleForm.toUser = row.delegatee;
      this.ruleForm.availableSP = row.amount;
      this.isOpenDelegate = true;
    },
    confirmDelegate: function confirmDelegate() {
      if (this.loginData[4] == "true") {
        var that = this;
        var transferAmount = toDecimal(this.ruleForm.transferAmount, 3);
        window.steem_keychain.requestDelegation(this.fromUser, this.ruleForm.toUser, transferAmount, "SP", function (response) {
          if (response.success) {
            that.finishDelegate();
          } else {
            ElMessage({
              message: that.$t("error.delegateError"),
              type: "error"
            });
          }
        });
      } else {
        this.isShowModelDelegate = true;
      }
    },
    finishDelegate: function finishDelegate() {
      ElMessage({
        message: this.$t("success.delegateSuccess"),
        type: "success"
      });
      this.isShowModelDelegate = false;
      this.isOpenDelegate = false;
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var state, total_vesting_fund_steem, total_vesting_shares;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this9.userName = _this9.$route.params.username.replace("@", "");
              _this9.loginData = extractLoginData();

              if (_this9.loginData) {
                _this9.currentUserName = _this9.loginData[0];
                _this9.isSelf = _this9.currentUserName == _this9.userName;
                _this9.fromUser = _this9.currentUserName;
              }

              _this9.loadAccount();

              _context6.next = 6;
              return dsteem.getAccountState("/@" + _this9.userName + "/transfers");

            case 6:
              state = _context6.sent;
              total_vesting_fund_steem = parseFloat(state.props.total_vesting_fund_steem.replace(" STEEM", ""));
              _this9.total_vesting_fund_steem = total_vesting_fund_steem;
              total_vesting_shares = parseFloat(state.props.total_vesting_shares.replace(" VESTS", ""));
              _this9.total_vesting_shares = total_vesting_shares;

              if (_this9.isPownDown) {
                _this9.powerDownSteem = (total_vesting_fund_steem * _this9.to_withdraw / 4 / 1e6 / total_vesting_shares).toFixed(3);
              }

              state.accounts[_this9.userName].transfer_history.forEach(function (element) {
                if (element[1].op[0] == "claim_reward_balance") {
                  var availableVESTS = parseFloat(element[1].op[1].reward_vests.replace(" VESTS", ""));
                  var vestSteem = total_vesting_fund_steem * availableVESTS / total_vesting_shares;
                  var powerTitle = vestSteem.toFixed(3) + " STEEM POWER";
                  var spTitle = element[1].op[1].reward_steem.replace(" STEEM", "") == "0.000" ? "" : element[1].op[1].reward_steem + " and ";
                  var sbdTitle = element[1].op[1].reward_sbd.replace(" SBD", "") == "0.000" ? "" : element[1].op[1].reward_sbd + " and ";
                  var totalTitle = "Claim rewards: " + spTitle + sbdTitle + powerTitle;
                  var data = {
                    date: _this9.dateDiff(element[1].timestamp),
                    title: totalTitle,
                    memo: ""
                  };

                  _this9.editableTabs[0].tableData.unshift(data);
                }

                if (element[1].op[0] == "transfer") {
                  var transfirst = element[1].op[1].from == _this9.userName ? $t("label.transferSend") : $t("label.transferRevice");
                  var amount = element[1].op[1].amount;
                  var transMid = element[1].op[1].from == _this9.userName ? $t("label.transferTo") : $t("label.transferFrom");
                  var destUser = element[1].op[1].from == _this9.userName ? element[1].op[1].to : element[1].op[1].from;
                  var _data = {
                    date: _this9.dateDiff(element[1].timestamp),
                    title: transfirst + " " + amount + " " + transMid + " <a href='/@" + destUser + "'>" + destUser + "</a>",
                    memo: element[1].op[1].memo
                  };

                  _this9.editableTabs[0].tableData.unshift(_data);
                }
              });

              getAllBoylikegirlClubOperTypeList().then(function (res) {
                _this9.editableTabs[1].boylikegirlClubOperTypeList = res.data.items;
              });
              getAllBoylikegirlClubPointList(_this9.userName).then(function (res) {
                _this9.editableTabs[1].boylikegirlClubOperPointList = res.data.items;
              });
              getAllBoylikegirlClubTotalPoints(_this9.userName).then(function (res) {
                _this9.points = res.data;
              });
              getSbiBalance(_this9.userName).then(function (res) {
                if (res.success) _this9.sbi = res.data.shares;
              });
              getUVFBalance(_this9.userName).then(function (res) {
                //console.log(res);
                if (res.code == 0) _this9.uvf = parseInt(res.data.totalUVF);
              });
              getIncomingDelegations(_this9.userName).then(function (res) {
                res.result.rows.forEach(function (element) {
                  var incoming = {
                    delegator: element[1],
                    amount: parseFloat(toDecimal(total_vesting_fund_steem * element[3] / total_vesting_shares, 3)),
                    date: timestampToTime(element[0])
                  };

                  _this9.editableTabs[2].incomingList.push(incoming);
                });
              });
              getOutgoingDelegations(_this9.userName).then(function (res) {
                res.result.rows.forEach(function (element) {
                  var outgoing = {
                    delegatee: element[2],
                    amount: parseFloat(toDecimal(total_vesting_fund_steem * element[3] / total_vesting_shares, 3)),
                    date: timestampToTime(element[0])
                  };

                  _this9.editableTabs[2].outgoingList.push(outgoing);
                });
              });
              getExpiringDelegations(_this9.userName).then(function (res) {
                res.result.rows.forEach(function (element) {
                  var expiring = {
                    delegatee: element[3],
                    amount: parseFloat(toDecimal(total_vesting_fund_steem * element[4] / total_vesting_shares, 3)),
                    date: timestampToTime(element[1])
                  };

                  _this9.editableTabs[2].expiringList.push(expiring);
                });
              });

            case 21:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
};